<template>
<div class="accordion" role="tablist">

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-button block v-b-toggle.accordion-1 style="background-color:#060745; color:#ffffff">Student Info</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <CCard>
              <br>
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-2">
                    <label><strong>Student Name</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="AAROON">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Student Grade</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="FORM 5/GRADE 11">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Student Class</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="-">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Parent Name</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="SHAHIRA">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Parent Email</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="office.shahira@advancedcellnet.com">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Status</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="active">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Parent Phone Number</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="0126240294">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Grade</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="FORM 5/GRADE 11">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Class</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="-">
                  </div>
                  <br>

                  <!-- REGISTRATION STUDENT -->
                  <div class="col-md-2">
                    <label><strong>IC Number</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="950812045205">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Birth Date</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="date" class="form-control" value="3/29/2022 12:00:00 AM">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Age</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="17">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Age</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="17">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Gender</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="male">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Main Contact</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="0126240294">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Facebook</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Occupation</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Zip Code</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>State</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control" value="No Data">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Home Phone Number</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Father Phone Number</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control">
                  </div>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Mother Phone Number</strong></label>
                  </div>
                  <div class="col-md-4">
                    <input name="text" class="form-control">
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Package Interest</strong></label>
                  </div>
                  <div class="col-md-4">
                    <label>form-4-bahasamalaysia;form-4-bahasainggeris</label>
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Remarks</strong></label>
                  </div>
                  <div class="col-md-4">
                    <label></label>
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>Allergy</strong></label>
                  </div>
                  <div class="col-md-4">
                    <label></label>
                  </div>
                  <br>
                  <br>
                  <div class="col-md-2">
                    <label><strong>School Name</strong></label>
                  </div>
                  <div class="col-md-4">
                    <label>No Data</label>
                  </div>
                </div>
              </div>
            </CCard>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-button block v-b-toggle.accordion-2 style="background-color:#060745; color:#ffffff">Schedule</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <CCard>
              <br>
              <CCol md="12">
                <div class="row">
                  <CCol md="6">
                    <label>Show 
                      <select class="form-control-sm">
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                      </select> entries
                    </label>
                  </CCol>
                  <CCol md="6">
                    <label class="pull-right">Search:
                      <input type="search" class="form-control-sm" placeholder="">
                    </label>
                  </CCol>
                </div>
                <div class="row">
                  <CCol sm="12">
                    <table class="table m-t-20 table-bordered table-hover table-striped" >
                      <thead>
                        <tr>
                          <th rowspan="1" colspan="1" style="width: 0px;">Date</th>
                          <th rowspan="1" colspan="1" style="width: 0px;">Time</th>
                          <th rowspan="1" colspan="1" style="width: 0px;">Subject</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td valign="top" colspan="3">No data available in table</td></tr>
                      </tbody>
                    </table>
                  </CCol>
                </div>
                <div class="row">
                  <CCol md="5">
                    <div>Showing 0 to 0 of 0 entries</div>
                  </CCol>
                  <CCol md="7">
                    <div class="pull-right">
                      <ul class="pagination">
                        <li>
                          <a href="#" class="page-link">Previous</a>
                        </li>
                        <li>
                          <a href="#" class="page-link">Next</a>
                        </li>
                      </ul>
                    </div>
                  </CCol>
                </div>
              </CCol>
            </CCard>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-button block v-b-toggle.accordion-3 style="background-color:#060745; color:#ffffff">Payment Info</b-button>
      </b-card-header>
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <CCard>
              <table class="table table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>Month</th>
                    <th>IsPaid</th>
                    <th>Payment Method</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>May 2022</td>
                    <td>No</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </CCard>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-button block v-b-toggle.accordion-4 style="background-color:#060745; color:#ffffff">Status Student</b-button>
      </b-card-header>
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <CCard>
              <br>
              <CCol md="12">
                <div class="row">
                  <CCol md="4">
                    <label>Student ID
                      <input type="number" value="13454" class="form-control-sm" readonly>
                    </label>
                  </CCol>
                  <CCol md="8">
                    <select class="form-control-sm col-2" >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>             
                    <input type="submit" value="Save Changes" class="btn-sm btn-success">             
                  </CCol>
                </div>
              </CCol>
            </CCard>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import _ from "lodash";
import Vue from "vue";
Vue.use(require("vue-moment"));
import moment from "moment";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import vSelect from "vue-select";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

Vue.use(VuejsDialog);

import CollapsePlugin from "bootstrap-vue";
Vue.use(CollapsePlugin);
export default {
    data() {
      return {
        text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
        `
      }
    }
  }
</script>

<style>
.collapsed > .when-open,
.not-collapsed > .when-closed {
  display: none;
}
</style>
